import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { XCircle, RefreshCw } from 'lucide-react';

const BookingFailed = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const { bookingId } = location.state || {};

    useEffect(() => {
        // Prevent back navigation
        const handlePopState = (e) => {
            e.preventDefault();
            navigate('/', { replace: true });
        };

        window.addEventListener('popstate', handlePopState);

        return () => {
            window.removeEventListener('popstate', handlePopState);
        };
    }, [navigate]);

    const handleTryAgain = () => {
        // Reset navigation stack and go to booking page
        window.history.replaceState(null, '', '/booking');
        navigate('/bookingsDetail', { replace: true });
    };

    const handleBackToHome = () => {
        // Reset navigation stack and go to home page
        window.history.replaceState(null, '', '/');
        navigate('/booking', { replace: true });
    };

    return (
        <div className="min-h-screen bg-white flex items-center justify-center">
            <div className="max-w-md mx-auto px-6">
                <div className="flex flex-col items-center text-center space-y-6">
                    {/* Error Icon with Animation */}
                    <div className="relative">
                        <div className="absolute inset-0 bg-red-100 rounded-full animate-ping opacity-75"></div>
                        <div className="relative bg-red-500 rounded-full p-6">
                            <XCircle size={80} className="text-white" strokeWidth={2} />
                        </div>
                    </div>

                    {/* Error Message */}
                    <div className="space-y-3">
                        <h1 className="text-4xl font-bold text-black">
                            Payment Failed
                        </h1>
                        <p className="text-slate-400 font-semibold text-lg px-4">
                            Your transaction has been failed due to some technical error. Please try again.
                        </p>
                    </div>

                    {/* Error Details Card (Optional) */}
                    {bookingId && (
                        <div className="bg-red-50 border border-red-200 rounded-lg p-4 w-full">
                            <p className="text-sm text-red-800">
                                <span className="font-semibold">Booking ID:</span> #{bookingId}
                            </p>
                            <p className="text-xs text-red-600 mt-1">
                                Your booking slot is still reserved. Complete payment to confirm.
                            </p>
                        </div>
                    )}

                    {/* Action Buttons */}
                    <div className="w-full space-y-3 pt-4">
                        <button
                            onClick={handleTryAgain}
                            className="w-full bg-red-500 hover:bg-red-600 text-white font-bold py-4 rounded-lg transition-colors shadow-md flex items-center justify-center gap-2"
                        >
                            <RefreshCw size={20} />
                            Try Again
                        </button>
                        <button
                            onClick={handleBackToHome}
                            className="w-full bg-slate-100 hover:bg-slate-200 text-red-500 font-bold py-4 rounded-lg transition-colors"
                        >
                            Back to Home
                        </button>
                    </div>

                    {/* Help Text */}
                    <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 w-full">
                        <p className="text-xs text-blue-800 text-center">
                            If you continue to face issues, please contact support or try a different payment method.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BookingFailed;
